export default __webpack_public_path__ + "static/media/e-ppt-logotype-l.aa491b7f.svg";